import categoryFieldsConfig from '../components/CreateListing/categoryFieldsConfig';

const LEGACY_ALIASES = {
  "Дім, Сад та затишок": "Дім та затишок",
  "Антикваріат": "Аксесуари",
};

const getPureCategory = (category) =>
  (category || '').replace(/^[^\wА-Яа-яІіЇїЄє]+/, '').trim();

function resolveCategoryKey(inputName) {
  const pure = getPureCategory(inputName);
  if (!pure) return null;

  const aliased = LEGACY_ALIASES[pure] || pure;

  if (categoryFieldsConfig[aliased]) return aliased;

  if (
    aliased === "Для саду та подвір'я" &&
    (categoryFieldsConfig["Дім, Сад та затишок"] || categoryFieldsConfig["Дім та затишок"])
  ) {
    return categoryFieldsConfig["Дім та затишок"]
      ? "Дім та затишок"
      : "Дім, Сад та затишок";
  }

  if (aliased === "Дім та затишок" && categoryFieldsConfig["Дім, Сад та затишок"]) {
    return "Дім, Сад та затишок";
  }

  if (aliased === "Аксесуари" && categoryFieldsConfig["Антикваріат"]) {
    return "Антикваріат";
  }

  if (categoryFieldsConfig[pure]) return pure;

  return aliased;
}

function getRawFields(categoryKey, attrs = {}) {
  const src = categoryKey ? categoryFieldsConfig[categoryKey] : null;
  if (!src) return [];

  let arr = [];
  if (typeof src === 'function') {
    arr = src(attrs) || [];
  } else if (Array.isArray(src)) {
    arr = src;
  }

  const seen = new Set();
  const out = [];
  for (const f of arr) {
    if (!f?.name) continue;
    if (seen.has(f.name)) continue;
    seen.add(f.name);
    out.push(f);
  }
  return out;
}

export function getCategoryFieldDefs(categoryName, attrs = {}) {
  const categoryKey = resolveCategoryKey(categoryName);
  const raw = getRawFields(categoryKey, attrs);

  const visible = raw.filter((f) => {
    if (!f?.showIf) return true;
    try {
      if (typeof f.showIf === 'function') return !!f.showIf(attrs);
      return Object.entries(f.showIf).every(([k, v]) => attrs?.[k] === v);
    } catch {
      return true;
    }
  });

  return visible;
}

export function collectAttributes(categoryName, attrsState = {}) {
  const defs = getCategoryFieldDefs(categoryName, attrsState);
  const allowed = new Set(defs.map((f) => f.name));

  const result = {};
  for (const [name, val] of Object.entries(attrsState || {})) {
    if (!allowed.has(name)) continue;
    if (val === null || val === undefined) continue;
    if (typeof val === 'string' && val.trim() === '') continue;
    if (Array.isArray(val) && val.length === 0) continue;

    result[name] = val;
  }

  return result;
}
